import React, { useRef, useState } from 'react';
import axiosBase from '../../../axios';
import { Button, Box, Typography, CircularProgress } from '@mui/material';

const SIZE_IMAGE_LIMIT = 1024 * 1024 * 1; // 1 Мб
const WIDTH_IMAGE_CONVERT = 1980;

const generateRandomString = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

const ImageUploaderMany = ({ url, folder, setArrLinkImg, arrLinkImg, maxNumImage, currentImagesCount = 0 }) => {
    const inputFileRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const handleChangeImg = async (event) => {
        try {
            const currentCount = currentImagesCount || arrLinkImg.length;
            
            if (maxNumImage && currentCount >= maxNumImage) {
                alert(`Максимальное количество изображений (${maxNumImage}) уже загружено`);
                return;
            }
            
            const img = event.target.files[0];
            if (!img) return;
            
            setUploading(true);
            
            // Генерируем уникальное имя файла
            const fileExtension = img.name.split('.').pop();
            const uniqueFileName = `${generateRandomString(8)}.${fileExtension}`;
            
            const formData = new FormData();
            // ВАЖНО: Используем уникальное имя файла, а не полный путь
            formData.append('image', img, uniqueFileName);
            
            console.log("📤 Загружаем файл:", uniqueFileName);
            console.log("🌐 URL:", `/${url}`);
            
            const uploadImage = async (imageFile) => {
                try {
                    const response = await axiosBase.post(`/${url}`, formData);
                    console.log("✅ Ответ сервера:", response.data);
                    
                    // Получаем URL из ответа сервера
                    const imageUrl = response.data.url;
                    console.log("🖼️ URL изображения:", imageUrl);
                    
                    setArrLinkImg(prevLinks => [...prevLinks, imageUrl]);
                    alert('Изображение успешно загружено!');
                } catch (error) {
                    console.error("❌ Ошибка загрузки:", error);
                    console.error("Детали:", error.response?.data);
                    alert(`Ошибка загрузки: ${error.response?.data?.error || error.message}`);
                } finally {
                    setUploading(false);
                }
            };

            if (img.size > SIZE_IMAGE_LIMIT) {
                console.log("🔄 Изображение больше 1MB, сжимаем...");
                const image = new Image();
                image.src = URL.createObjectURL(img);
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = WIDTH_IMAGE_CONVERT;
                    canvas.height = (image.height / image.width) * canvas.width;
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    
                    canvas.toBlob((blob) => {
                        const newFormData = new FormData();
                        newFormData.append('image', blob, uniqueFileName);
                        axiosBase.post(`/${url}`, newFormData)
                            .then(response => {
                                console.log("✅ Ответ сервера (сжатое):", response.data);
                                setArrLinkImg(prevLinks => [...prevLinks, response.data.url]);
                                alert('Изображение успешно загружено!');
                            })
                            .catch(error => {
                                console.error("❌ Ошибка загрузки:", error);
                                alert(`Ошибка загрузки: ${error.response?.data?.error || error.message}`);
                            })
                            .finally(() => setUploading(false));
                    }, 'image/jpeg', 0.9);
                    
                    URL.revokeObjectURL(image.src);
                };
            } else {
                uploadImage(img);
            }
            
            event.target.value = '';
            
        } catch (err) {
            console.warn('❌ Ошибка:', err);
            alert('Произошла ошибка при загрузке изображения');
            setUploading(false);
        }
    };

    return (
        <Box m={2}>
            <Button 
                onClick={() => inputFileRef.current.click()}
                variant="outlined" 
                size="large"
                disabled={uploading}
                sx={{mr: "20px"}}
            >
                {uploading ? <CircularProgress size={24} /> : `Загрузить изображение (${arrLinkImg.length}/${maxNumImage || '∞'})`}
            </Button>
            <input 
                ref={inputFileRef}
                type="file" 
                onChange={handleChangeImg} 
                accept="image/jpeg,image/png,image/jpg,image/webp"
                hidden 
            />
            {arrLinkImg.length > 0 && (
                <Typography variant="caption" color="success.main" sx={{ ml: 2 }}>
                    ✓ Загружено: {arrLinkImg.length} фото
                </Typography>
            )}
        </Box>
    );
};

export default ImageUploaderMany;